/* tslint:disable */
/*
 * Autogenerated by @creditkarma/thrift-typescript v2.0.14
 * DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
*/
import * as thrift from "thrift";
import * as GenericExceptions from "./../../thrift/protocol/common/exceptions";
import * as PHeader from "./../../thrift/protocol/common/models";
import * as RequestInfo from "./../../thrift/protocol/contactinfo/messages";
export namespace TContactInfoService {
    export interface IGenerateContactInfoUrlArgsArgs {
        header: PHeader.TAuthHeader;
        request: RequestInfo.TGenerateContactInfoUrlRequest;
    }
    export class GenerateContactInfoUrlArgs {
        public header: PHeader.TAuthHeader;
        public request: RequestInfo.TGenerateContactInfoUrlRequest;
        constructor(args: IGenerateContactInfoUrlArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("GenerateContactInfoUrlArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): GenerateContactInfoUrlArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_1: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_1;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_2: RequestInfo.TGenerateContactInfoUrlRequest = RequestInfo.TGenerateContactInfoUrlRequest.read(input);
                            _args.request = value_2;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new GenerateContactInfoUrlArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read GenerateContactInfoUrlArgs from input");
            }
        }
    }
    export interface ISubmitContactInfoArgsArgs {
        request: RequestInfo.TSubmitContactInfoRequest;
    }
    export class SubmitContactInfoArgs {
        public request: RequestInfo.TSubmitContactInfoRequest;
        constructor(args: ISubmitContactInfoArgsArgs) {
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("SubmitContactInfoArgs");
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 1);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): SubmitContactInfoArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_3: RequestInfo.TSubmitContactInfoRequest = RequestInfo.TSubmitContactInfoRequest.read(input);
                            _args.request = value_3;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.request !== undefined) {
                return new SubmitContactInfoArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read SubmitContactInfoArgs from input");
            }
        }
    }
    export interface IGenerateContactInfoUrlResultArgs {
        success?: RequestInfo.TGenerateContactInfoUrlResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class GenerateContactInfoUrlResult {
        public success?: RequestInfo.TGenerateContactInfoUrlResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IGenerateContactInfoUrlResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("GenerateContactInfoUrlResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): GenerateContactInfoUrlResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_4: RequestInfo.TGenerateContactInfoUrlResponse = RequestInfo.TGenerateContactInfoUrlResponse.read(input);
                            _args.success = value_4;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_5: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_5;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_6: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_6;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new GenerateContactInfoUrlResult(_args);
        }
    }
    export interface ISubmitContactInfoResultArgs {
        success?: RequestInfo.TSubmitContactInfoResponse;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
        requestExpiredError?: GenericExceptions.TRequestExpired;
    }
    export class SubmitContactInfoResult {
        public success?: RequestInfo.TSubmitContactInfoResponse;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        public requestExpiredError?: GenericExceptions.TRequestExpired;
        constructor(args?: ISubmitContactInfoResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
            if (args != null && args.requestExpiredError != null) {
                this.requestExpiredError = args.requestExpiredError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("SubmitContactInfoResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 1);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            if (this.requestExpiredError != null) {
                output.writeFieldBegin("requestExpiredError", thrift.Thrift.Type.STRUCT, 2);
                this.requestExpiredError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): SubmitContactInfoResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_7: RequestInfo.TSubmitContactInfoResponse = RequestInfo.TSubmitContactInfoResponse.read(input);
                            _args.success = value_7;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_8: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_8;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_9: GenericExceptions.TRequestExpired = GenericExceptions.TRequestExpired.read(input);
                            _args.requestExpiredError = value_9;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new SubmitContactInfoResult(_args);
        }
    }
    export class Client {
        public _seqid: number;
        public _reqs: {
            [name: number]: (err: Error | object | undefined, val?: any) => void;
        };
        public output: thrift.TTransport;
        public protocol: new (trans: thrift.TTransport) => thrift.TProtocol;
        constructor(output: thrift.TTransport, protocol: new (trans: thrift.TTransport) => thrift.TProtocol) {
            this._seqid = 0;
            this._reqs = {};
            this.output = output;
            this.protocol = protocol;
        }
        public incrementSeqId(): number {
            return this._seqid += 1;
        }
        public generateContactInfoUrl(header: PHeader.TAuthHeader, request: RequestInfo.TGenerateContactInfoUrlRequest): Promise<RequestInfo.TGenerateContactInfoUrlResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<RequestInfo.TGenerateContactInfoUrlResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_generateContactInfoUrl(header, request, requestId);
            });
        }
        public submitContactInfo(request: RequestInfo.TSubmitContactInfoRequest): Promise<RequestInfo.TSubmitContactInfoResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<RequestInfo.TSubmitContactInfoResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_submitContactInfo(request, requestId);
            });
        }
        public send_generateContactInfoUrl(header: PHeader.TAuthHeader, request: RequestInfo.TGenerateContactInfoUrlRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("generateContactInfoUrl", thrift.Thrift.MessageType.CALL, requestId);
            const args: GenerateContactInfoUrlArgs = new GenerateContactInfoUrlArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_submitContactInfo(request: RequestInfo.TSubmitContactInfoRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("submitContactInfo", thrift.Thrift.MessageType.CALL, requestId);
            const args: SubmitContactInfoArgs = new SubmitContactInfoArgs({ request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public recv_generateContactInfoUrl(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: GenerateContactInfoUrlResult = GenerateContactInfoUrlResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "generateContactInfoUrl failed: unknown result"));
                    }
                }
            }
        }
        public recv_submitContactInfo(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: SubmitContactInfoResult = SubmitContactInfoResult.read(input);
                input.readMessageEnd();
                if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else if (result.requestExpiredError != null) {
                    return callback(result.requestExpiredError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "submitContactInfo failed: unknown result"));
                    }
                }
            }
        }
    }
    export interface IHandler {
        generateContactInfoUrl(header: PHeader.TAuthHeader, request: RequestInfo.TGenerateContactInfoUrlRequest): RequestInfo.TGenerateContactInfoUrlResponse | Promise<RequestInfo.TGenerateContactInfoUrlResponse>;
        submitContactInfo(request: RequestInfo.TSubmitContactInfoRequest): RequestInfo.TSubmitContactInfoResponse | Promise<RequestInfo.TSubmitContactInfoResponse>;
    }
    export class Processor {
        public _handler: IHandler;
        constructor(handler: IHandler) {
            this._handler = handler;
        }
        public process(input: thrift.TProtocol, output: thrift.TProtocol): void {
            const metadata: thrift.TMessage = input.readMessageBegin();
            const fname: string = metadata.fname;
            const requestId: number = metadata.rseqid;
            const methodName: string = "process_" + fname;
            switch (methodName) {
                case "process_generateContactInfoUrl": {
                    this.process_generateContactInfoUrl(requestId, input, output);
                    return;
                }
                case "process_submitContactInfo": {
                    this.process_submitContactInfo(requestId, input, output);
                    return;
                }
                default: {
                    input.skip(thrift.Thrift.Type.STRUCT);
                    input.readMessageEnd();
                    const errMessage = "Unknown function " + fname;
                    const err = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN_METHOD, errMessage);
                    output.writeMessageBegin(fname, thrift.Thrift.MessageType.EXCEPTION, requestId);
                    err.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            }
        }
        public process_generateContactInfoUrl(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<RequestInfo.TGenerateContactInfoUrlResponse>((resolve, reject): void => {
                try {
                    const args: GenerateContactInfoUrlArgs = GenerateContactInfoUrlArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.generateContactInfoUrl(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: RequestInfo.TGenerateContactInfoUrlResponse): void => {
                const result: GenerateContactInfoUrlResult = new GenerateContactInfoUrlResult({ success: data });
                output.writeMessageBegin("generateContactInfoUrl", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: GenerateContactInfoUrlResult = new GenerateContactInfoUrlResult({ authFailedError: err });
                    output.writeMessageBegin("generateContactInfoUrl", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: GenerateContactInfoUrlResult = new GenerateContactInfoUrlResult({ invalidRequestError: err });
                    output.writeMessageBegin("generateContactInfoUrl", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("generateContactInfoUrl", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_submitContactInfo(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<RequestInfo.TSubmitContactInfoResponse>((resolve, reject): void => {
                try {
                    const args: SubmitContactInfoArgs = SubmitContactInfoArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.submitContactInfo(args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: RequestInfo.TSubmitContactInfoResponse): void => {
                const result: SubmitContactInfoResult = new SubmitContactInfoResult({ success: data });
                output.writeMessageBegin("submitContactInfo", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: SubmitContactInfoResult = new SubmitContactInfoResult({ invalidRequestError: err });
                    output.writeMessageBegin("submitContactInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TRequestExpired) {
                    const result: SubmitContactInfoResult = new SubmitContactInfoResult({ requestExpiredError: err });
                    output.writeMessageBegin("submitContactInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("submitContactInfo", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
    }
}
